import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorLabel: string;
    loadingShares: string;
    shareLinks: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message when share links fail to load */
            errorLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "StaticShares.errorLabel?c=245rbbhhuxxl8", defaultMessage: "An error has occurred retrieving Share Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria-label for shares section loading state */
            loadingShares: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "StaticShares.loadingShares?c=2u9ehjik91acy", defaultMessage: "Loading shares" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section title for Share Links */
            shareLinks: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "StaticShares.shareLinks?c=28kqp4avhjurx", defaultMessage: "Share Links" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
